import { ref, onBeforeUnmount } from "vue";
import { isEmpty } from "@utils/var.check";
import { useModal } from "@/plugins/modal/composables/modal-instance";
import { NavigationFailure } from "vue-router";

type RoutePushResult = NavigationFailure | void | undefined;

export function useRouting() {
  const modal = useModal();

  const switchingView = ref(false);
  const refreshIntervalId = ref<NodeJS.Timeout | null>(null);
  const urlReady = ref<string | null>(null);
  const urlReadyAndCloseModal = ref(false);
  const target = ref("_blank");

  const pushRoute = async (pushFunc: () => Promise<RoutePushResult>) => {
    if (switchingView.value) {
      return;
    }
    switchingView.value = true;
    try {
      return await pushFunc();
    } finally {
      switchingView.value = false;
    }
  };

  const handleRouteIntervalCheck = () => {
    urlReadyAndCloseModal.value = false;
    urlReady.value = null;

    if (refreshIntervalId.value) {
      clearInterval(refreshIntervalId.value);
    }

    refreshIntervalId.value = setInterval(() => {
      if (urlReady.value !== null) {
        if (!isEmpty(target.value)) {
          console.log("opening new tab with target " + urlReady.value);
          window.open(urlReady.value, target.value);
        } else {
          console.log("opening new tab " + urlReady.value);
          window.open(urlReady.value);
        }

        if (urlReadyAndCloseModal.value && modal?.removeAll) {
          urlReadyAndCloseModal.value = false;
          modal.removeAll();
        }

        if (refreshIntervalId.value) {
          clearInterval(refreshIntervalId.value);
          refreshIntervalId.value = null;
        }
      }
    }, 500);
  };

  onBeforeUnmount(() => {
    if (refreshIntervalId.value) {
      clearInterval(refreshIntervalId.value);
    }
  });

  return {
    switchingView,
    refreshIntervalId,
    urlReady,
    urlReadyAndCloseModal,
    target,
    pushRoute,
    handleRouteIntervalCheck,
  };
}
